import React from "react";
import Header from "@/components/Header";
import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import Footer from "@/components/Footer";
import Faq from "@/components/landing/Faq";

export default function PrivacyPolicyPage() {
  return (
    <div className="">
      <Head>
        {generateNextSeo({
          title: "Uptime Monitor FAQs - Everything You Need to Know",
          description:
            "Get answers to frequently asked questions about Uptime Monitor. Discover how our service ensures the availability of your websites and servers with advanced monitoring and instant notifications.",
          canonical: "https://uptime-monitor.io/faq",
          openGraph: {
            title: "Frequently Asked Questions - Uptime Monitor",
            description:
              "Get answers to common questions about uptime monitoring, alerts, status pages, and more.",
            url: "https://uptime-monitor.io/faq",
          },
        })}
      </Head>
      <div>
        <Header />

        <Faq />

        <Footer />
      </div>
    </div>
  );
}
